module.exports = __webpack_public_path__ + "static/media/semObservacoes.d586d3f9.PNG";